import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var VoucherListRes;
export const VoucherListTodo = createAsyncThunk('VoucherList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'discount_voucher_list',
            data: {
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "vcust_plant_code": localStorage.getItem('vcust_plant_code'),
                "vfrom_date": data?.fromDate,
                "vto_date": data?.toDate,
                "vdesc_account_code": "",
            },
            headers: { "Content-Type": "application/json" },

        })
        return VoucherListRes = res.data

    } catch (error) {
        return VoucherListRes = error.response.data
    }
});

const VoucherListSlice = createSlice({
    name: 'VoucherList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(VoucherListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(VoucherListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default VoucherListSlice.reducer; 